import React, { useEffect, useState } from 'react';
import { Banner, BannerNote } from '@ferris/react/components/banner';
import cn from 'classnames';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import { Checkbox } from '@ferris/react/components/forms';
import { Icon } from '@ferris/react';
import {
    VALID_GEO_CODE,
    DEFAULT,
    ERROR_INFORMATION
} from '../../../../utils/ErrorUtil';
import { createInteractionEvent } from '../../../../utils/EventProviders/EgClickstreamUtil';
import log from '../../../../utils/ClientLogger';

const checkboxCodes = [
    VALID_GEO_CODE,
    DEFAULT
];

const ConfirmAddressCheckbox = ({
    getTranslation,
    handleCheck,
    noteText
}) => {
    const [isChecked, setIsChecked] = useState(false);
    const onChange = (e) => {
        setIsChecked(e.target.checked);
        handleCheck(e);
    };

    return (
        <>
            <Checkbox
                name="no-unit-number-confirmation"
                label={getTranslation('Vrbo.lyp.manualLocation.confirmAddress.checkbox')}
                onChange={onChange}
            />
            {
                isChecked && noteText && (
                    <p>
                        {
                            noteText
                        }
                    </p>
                )
            }
        </>
    );
};

ConfirmAddressCheckbox.propTypes = {
    getTranslation: PropTypes.func.isRequired,
    handleCheck: PropTypes.func.isRequired,
    noteText: PropTypes.func.isRequired
};

// even though it is an error list, currently it
// only supports erros from the geovalidating service,
// meaning there will be only one item in the list
const ErrorBanner = (props) => {
    const {
        errors,
        getTranslation,
        setCanBypassValidation,
        setConfirmsCorrectAddress,
        trigger,
        address,
        isCl,
        display
    } = props;

    if (!display) return null;

    const classes = cn('alert-banner');
    const translatedText = getTranslation(ERROR_INFORMATION[errors[0]]?.error_translation);
    const addressConfirmationOption = checkboxCodes.includes(errors[0]);
    const options = {
        replace: ({ attribs, name, children }) => {
            if (!attribs) return;
            if (name === 'a') {
                // eslint-disable-next-line consistent-return
                return (
                    <a href={attribs.href} target="_blank" rel="noreferrer">
                        {domToReact(children)}
                    </a>
                );
            }
        }
    };
    const noteText = isCl ? null : parse(
        getTranslation('Vrbo.lyp.manualLocation.confirmAddress.note'),
        options
    );

    useEffect(() => {
        setCanBypassValidation(addressConfirmationOption);
        setConfirmsCorrectAddress(false);
    }, [addressConfirmationOption]);

    const handleCheck = (e) => {
        trigger('interaction', createInteractionEvent(`confirm_address.${e.target.checked ? 'selected' : 'deselected'}`, 'ManualLocation', 'ManualLocation.ErrorBanner', undefined, '2.3.0'));
        setConfirmsCorrectAddress(e.target.checked);
        log('info', 'Address Validation - Checkbox clicked', {
            selected: e.target.checked,
            address
        });
    };

    return (
        <Banner
            type="attention"
            scope="content"
            classes={classes}
            icon={(
                <Icon
                    name="warning"
                    title="attention"
                />
            )}
        >
            <BannerNote>
                {
                    parse(translatedText)
                }
                {
                    addressConfirmationOption && (
                        <ConfirmAddressCheckbox
                            getTranslation={getTranslation}
                            handleCheck={handleCheck}
                            noteText={noteText}
                        />
                    )
                }
            </BannerNote>
        </Banner>
    );
};

ErrorBanner.propTypes = {
    errors: PropTypes.arrayOf(PropTypes.string).isRequired,
    getTranslation: PropTypes.func.isRequired,
    setConfirmsCorrectAddress: PropTypes.func.isRequired,
    setCanBypassValidation: PropTypes.func.isRequired,
    trigger: PropTypes.func.isRequired,
    address: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        stateProvince: PropTypes.string,
        postalCode: PropTypes.string,
        country: PropTypes.string
    }).isRequired,
    isCl: PropTypes.bool.isRequired,
    display: PropTypes.bool.isRequired
};
export default ErrorBanner;
